/* El Ropero de la Anita — textos de envío de Turbo Progress Bar.
   Cubre la ficha del producto y la ventana de confirmación del carrito.
   No modifica tarifas, checkout ni funcionamiento de la barra de progreso. */
(function () {
  'use strict';

  function fixLabels(root) {
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var element = node.parentElement;
      if (!element || element.closest('script,style,noscript')) continue;
      var original = node.nodeValue || '';
      var revised = original;

      if (/3[.,]990\s+tarifa\s+fija/i.test(revised)) {
        revised = revised.replace(/3[.,]990\s+tarifa\s+fija/ig, '3.990 hasta $24.999');
      } else if (/tarifa\s+fija/i.test(revised) && /3[.,]990/.test(element.parentElement?.textContent || '')) {
        revised = revised.replace(/tarifa\s+fija/ig, 'hasta $24.999');
      }

      var isBenefit = /env[ií]o\s+gratis\s+en\s+compras\s+desde\s+\$?\s*49[.,]990/i.test(revised);
      revised = revised.replace(
        /env[ií]o\s+gratis\s+en\s+compras\s+desde\s+\$?\s*49[.,]990/ig,
        'PROMO $2.990 desde $25.000 · GRATIS desde $49.990'
      );

      if (revised !== original) node.nodeValue = revised;
      if (isBenefit || /PROMO\s+\$?2[.,]990\s+desde\s+\$?25[.,]000/i.test(revised)) {
        element.classList.add('anita-shipping-benefits-label');
      }
    }
  }

  var roots = ['MainContent', 'cart-notification'];
  var scheduled = false;
  function repair() {
    roots.forEach(function (id) { fixLabels(document.getElementById(id)); });
  }
  function scheduleRepair() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      repair();
    });
  }
  function watchRoot(root) {
    if (!root || root.dataset.anitaShippingLabelsObserved === 'yes') return;
    root.dataset.anitaShippingLabelsObserved = 'yes';
    var observer = new MutationObserver(scheduleRepair);
    observer.observe(root, {subtree:true,childList:true,characterData:true});
  }
  function boot() {
    if (!document.getElementById('anita-shipping-text-style')) {
      var css = document.createElement('style');
      css.id = 'anita-shipping-text-style';
      css.textContent = '.anita-shipping-benefits-label{color:#24364d!important;opacity:1!important;font-style:normal!important;font-weight:650!important;line-height:1.45!important;}';
      document.head.appendChild(css);
    }
    roots.forEach(function (id) { watchRoot(document.getElementById(id)); });
    repair();
    document.addEventListener('shopify:section:load', function () {
      roots.forEach(function (id) { watchRoot(document.getElementById(id)); });
      scheduleRepair();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();